import { render, staticRenderFns } from "./header-action.vue?vue&type=template&id=23bc2f88"
import script from "./header-action.vue?vue&type=script&lang=js"
export * from "./header-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports